import React, { lazy, Suspense } from 'react'
import { bookedPageViewTypes } from './my-live-sessions-utils'
import { CircularProgress } from '@mui/material'

const MyLiveSessionsPage = lazy(() => import('.'))
const BookANewSessionPage = lazy(() => import('./BookANewSessionPage')) // Adjust the path if needed

export default function MyLiveSessionPageToRender({ pageViewType, ...rest }) {
  let PageToRender = BookANewSessionPage

  if (pageViewType === bookedPageViewTypes.booked_sessions) {
    PageToRender = MyLiveSessionsPage
  }
  return (
    <Suspense fallback={<CircularProgress />}>
      <PageToRender {...rest} />
    </Suspense>
  )
}
